let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cAC7C")).then(() => parcelRequire('ix2bE'));